import SelectCard from "./SelectCard";
import React, { useState } from "react";

const Cards = ({
   page,
   handleArchivar = () => {},
   selects,
   NavigationControl,
    aplicaciones,
    contextos
}) => {

    const [currentActive, setCurrentActive] = useState({
        id: null
    });

    const selectCheck = (e, index) => {
        let y = document.getElementById(e.target.id);
        let concesionaria = page[index].original;
        if (y.checked) {
            selects(concesionaria, "push");
        } else {
            selects(concesionaria, "pop");
        }
    };

    return (
        <div className="cards__view">
            <div>
                {
                    page.map((item, index) => {
                        return <SelectCard
                            key={index}
                            infoCard={item}
                            handleArchivar={handleArchivar}
                            index={index}
                            selectCheck={selectCheck}
                            aplicaciones={aplicaciones}
                            currentActive={currentActive}
                            setCurrentActive={setCurrentActive}
                            contextos={contextos}
                        />
                    })
                }
            </div>
            <div className={"cards__navigation"}>
                <NavigationControl />
            </div>
        </div>
    );
}

export default Cards;